angular.module('tuitionFeesModule.filters.calculateBilledAmount', [])
    .filter('calculateBilledAmount', function () {        
        return function (items) {
            return items.map(item => {
                item.billedAmount = Math.max(0, item.price - item.discount);
                return item;
            });
        }
    });
